enum PATH {
    HOME = '/',
    CAMPS_CLASSICS = '/tabere-limbi-clasice',
    CAMPS_ENGLISH = '/tabere-engleza',
    REGISTRATIONS = '/inscrieri',
    CONTACT = '/contact',
}

export default PATH;